import { unsafeAsDraft } from '@ipfabric/utils/immer/unsafeAsDraft';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SetContentWrapperCommand {
  contentWrapper: HTMLElement | null;
}

export const setContentWrapper: GlobalStateCommandFactory<
  SetContentWrapperCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.contentWrapper = unsafeAsDraft(command.contentWrapper);
  });
};
